export default {
  getNotifications: (state) => state.notifications,
  getUnreadCount: (state) => state.unreadCount,
  getCurrentNotification: (state) => state.currentNotification,
  getToggleNotificationModal: (state) => state.isNotificationModalVisible,
};
